import React, { memo } from 'react'

import { classnames, Icon, Upload2 } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func } from 'prop-types'

import { iconSizeLarge, iconSizeMedium } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

import useBreakpoint from 'Utils/useBreakpoint'

import usePickerUpload from '../../Hooks/usePickerUpload'

function UploadTile({ onUploadStart }) {
  const t = useTranslation()
  const { accept, inputRef, isLoading, onFileChange, onFileClick } = usePickerUpload(onUploadStart)
  const label = t('threeDModelPicker.uploadTile')
  // Two cards to a row below 640px leaves the tile 93px tall at a 320px viewport, where
  // the desktop icon and body-md label overflow it - the longer translations wrap to two
  // lines. The tile steps down with the box it has to fit in.
  const isCompact = useBreakpoint() === 'xs'

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        accept={accept}
        onChange={!isLoading ? onFileChange : undefined}
        aria-hidden
        tabIndex={-1}
        disabled={isLoading}
        style={{ display: 'none' }}
      />
      <button
        type="button"
        className="three-d-model-picker__card three-d-model-picker__card--upload"
        onClick={!isLoading ? onFileClick : undefined}
        disabled={isLoading}
      >
        <Icon svgComponent={Upload2} size={isCompact ? iconSizeMedium : iconSizeLarge} color="dark" notSpaced />
        <span
          className={classnames(
            'three-d-model-picker__card-label',
            isCompact ? 'cgt-body-base-semibold' : 'cgt-body-md-semibold',
          )}
        >
          {label}
        </span>
      </button>
    </>
  )
}

UploadTile.propTypes = {
  onUploadStart: func.isRequired,
}

export default memo(UploadTile)
